import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Poliza } from '../modles/poliza.model';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { Usuario } from 'app/main/utilerias/models/usuarios/usuario';
import { Incisos } from '../modles/incisos.model';
import { CustomValidators } from 'ngx-custom-validators';
import { AuthService } from 'app/shared/services/auth.service';
import { Ramo } from 'app/main/ramos/models/ramos';
import { map } from 'rxjs/operators';

import { NgxDrpOptions, Range } from 'ngx-mat-daterange-picker';
const BACKEND_URL = environment.apiUrl + '/polizas/';
const BACKEND_URL_SOLICIT = environment.apiUrl + '/solicit/';
const BACKEND_URL_CATEG = environment.apiUrl + '/categtareas/';
const BACKEND_URL_FORMAS_PAGO = environment.apiUrl + '/formaspago';
const BACKEND_URL_CONTROL = environment.apiUrl + '/control';
const BACKEND_URL_RECIBOS = environment.apiUrl + '/recibos/';

@Injectable({
  providedIn: 'root'
})
export class PolizaService {
  obtenerIncisoNuevo(): Incisos {
    const inciso: Incisos = {
      actualizacion: null,
      in_cia: null,
      in_cob: null,
      in_dato1: null,
      in_dato2: null,
      in_dato3: null,
      in_dato4: null,
      in_dato5: null,
      in_dato6: null,
      in_descuento: null,
      in_estado: null,
      in_falta: null,
      in_fecha1: null,
      in_fecha2: null,
      in_gastos: null,
      in_id: null,
      in_imp1: null,
      in_imp2: null,
      in_iva: null,
      in_llave: null,
      in_num: null,
      in_numero1: null,
      in_numero2: null,
      in_pol: null,
      in_primaneta: null,
      in_prodcob1: null,
      in_prodcob2: null,
      in_prodcob3: null,
      in_prodcob4: null,
      in_prodcob5: null,
      in_prodcob6: null,
      in_ramo: null,
      in_recargos: null,
      in_tipo: null,
      in_total: null
    };
    return inciso;
  }
  constructor(private http: HttpClient, private fb: FormBuilder, private authService: AuthService) { }

  obtenerFormularioPoliza(usuario: Usuario): FormGroup {
    const valorEmitidaPor = {
      value: usuario.usua,
      disabled: (usuario.procc && usuario.procc.length > 0) ? false : true
    };

    return this.fb.group({
      datosPoliza: this.fb.group({
        id: new FormControl(null),
        sl_cia: new FormControl(null, [Validators.required]),
        sl_tipo: new FormControl(null, [Validators.required]),
        sl_sol: new FormControl(null, [Validators.maxLength(25)]),
        sl_pol: new FormControl(null, [Validators.required, Validators.maxLength(25)]),
        sl_edo: new FormControl(null),
        archivos: new FormControl(null),
        sl_mon: new FormControl(null, [Validators.required]),
      }),
      datosContratante: this.fb.group({
        sl_vig1: new FormControl(null, [Validators.required]), // SL_VIG1 y SL_VIG2 sl_vig1, sl_vig2
        sl_fpol: new FormControl(null, [Validators.required]),
        sl_cap: new FormControl(valorEmitidaPor),
        sl_num: new FormControl('', [Validators.required]),
        sl_aseg: new FormControl(null, [Validators.required, Validators.maxLength(150)]),
        sl_dom: new FormControl(null),
        sl_falta: new FormControl(null),
        sl_fpa: new FormControl(null, [Validators.required]),
        sl_vpag: new FormControl(null), // SL_VPAG y SL_DESVPAG sl_vpag
        conductoPago: new FormControl({ value: null, disabled: true }),
        sl_contrato: new FormControl(null),
        sl_caratula: new FormControl(null),
        sl_age: new FormControl(null, [Validators.required, Validators.maxLength(10)]),
        sl_codclt: new FormControl(null),
        sl_cob: new FormControl(null, [Validators.required])
      }),
      datosImportes: this.fb.group({
        noCalcularImportes: new FormControl(true),
        sl_pri: new FormControl(null, [Validators.required, CustomValidators.number]),
        sl_descto: new FormControl(null, [Validators.required, CustomValidators.number]),
        sl_derp: new FormControl(null, [CustomValidators.number]),
        sl_iva: new FormControl(null),
        sl_primtot: new FormControl(null, [Validators.required, CustomValidators.number]),
        sl_1erp: new FormControl(null, [Validators.required, CustomValidators.number]),
        sl_sigp: new FormControl(null, [CustomValidators.number]),
        sl_com: new FormControl(null, [CustomValidators.number]),
        sl_pfra: new FormControl(0)
      }),
      datosObservaciones: this.fb.group({
        sl_obs1: new FormControl(null, [Validators.required, Validators.maxLength(1000)]),
        sl_obs2: new FormControl(null, [Validators.maxLength(1000)]),
        sl_obs4: new FormControl(null, [Validators.maxLength(2000)]),
      }),
      datosUnidades: this.fb.group({ incisos: new FormControl(null) })
    });
  }

  // obtenerFormularioPoliza(usuario: Usuario): FormGroup {
  //   const valorEmitidaPor = {
  //     value: usuario.usua,
  //     disabled: (usuario.procc && usuario.procc.length > 0) ? false : true
  //   };

  //   return this.fb.group({
  //     datosPoliza: this.fb.group({
  //       sl_cia: new FormControl(null),
  //       sl_tipo: new FormControl(null),
  //       sl_sol: new FormControl(null),
  //       sl_pol: new FormControl(null),
  //       sl_edo: new FormControl(null),
  //       archivos: new FormControl(null),
  //       sl_mon: new FormControl(null),
  //     }),
  //     datosContratante: this.fb.group({
  //       sl_vig1: new FormControl(null), // SL_VIG1 y SL_VIG2 sl_vig1, sl_vig2
  //       sl_fpol: new FormControl(null),
  //       sl_cap: new FormControl(valorEmitidaPor),
  //       sl_num: new FormControl(''),
  //       sl_aseg: new FormControl(null),
  //       sl_dom: new FormControl(null),
  //       sl_falta: new FormControl(null),
  //       sl_fpa: new FormControl(null),
  //       sl_vpag: new FormControl(null), // SL_VPAG y SL_DESVPAG sl_vpag
  //       conductoPago: new FormControl({ value: null, disabled: true }),
  //       sl_contrato: new FormControl(null),
  //       sl_caratula: new FormControl(null),
  //       sl_age: new FormControl(null),
  //       sl_codclt: new FormControl(null),
  //       sl_cob: new FormControl(null)
  //     }),
  //     datosImportes: this.fb.group({
  //       noCalcularImportes: new FormControl(true),
  //       sl_pri: new FormControl(null),
  //       sl_descto: new FormControl(null),
  //       sl_derp: new FormControl(null),
  //       sl_iva: new FormControl(null),
  //       sl_primtot: new FormControl(null),
  //       sl_1erp: new FormControl(null),
  //       sl_sigp: new FormControl(null),
  //       sl_com: new FormControl(null),
  //       sl_pfra: new FormControl(0)
  //     }),
  //     datosObservaciones: this.fb.group({
  //       sl_obs1: new FormControl(null),
  //       sl_obs2: new FormControl(null),
  //       sl_obs4: new FormControl(null),
  //     }),
  //     datosUnidades: this.fb.group({ incisos: new FormControl(null) })
  //   });
  // }

  // obtenerFormularioPoliza(usuario: Usuario): FormGroup {
  //   const valorEmitidaPor = {
  //     value: usuario.usua,
  //     disabled: (usuario.procc && usuario.procc.length > 0) ? false : true
  //   };

  //   return this.fb.group({
  //     datosPoliza: this.fb.group({
  //       sl_cia: new FormControl(null),
  //       sl_tipo: new FormControl(null),
  //       sl_sol: new FormControl(null),
  //       sl_pol: new FormControl(null),
  //       sl_edo: new FormControl(null),
  //       archivos: new FormControl(null),
  //       sl_mon: new FormControl(null),
  //     }),
  //     datosContratante: this.fb.group({
  //       sl_vig1: new FormControl(null), // SL_VIG1 y SL_VIG2 sl_vig1, sl_vig2
  //       sl_fpol: new FormControl(null),
  //       sl_cap: new FormControl(valorEmitidaPor),
  //       sl_num: new FormControl(''),
  //       sl_aseg: new FormControl(null),
  //       sl_dom: new FormControl(null),
  //       sl_falta: new FormControl(null),
  //       sl_fpa: new FormControl(null),
  //       sl_vpag: new FormControl(null), // SL_VPAG y SL_DESVPAG sl_vpag
  //       conductoPago: new FormControl({ value: null, disabled: true }),
  //       sl_contrato: new FormControl(null),
  //       sl_caratula: new FormControl(null),
  //       sl_age: new FormControl(null),
  //       sl_codclt: new FormControl(null),
  //       sl_cob: new FormControl(null)
  //     }),
  //     datosImportes: this.fb.group({
  //       noCalcularImportes: new FormControl(false),
  //       sl_pri: new FormControl(0),
  //       sl_descto: new FormControl(null),
  //       sl_derp: new FormControl(0),
  //       sl_iva: new FormControl(0),
  //       sl_primtot: new FormControl(0),
  //       sl_1erp: new FormControl(0),
  //       sl_sigp: new FormControl(0),
  //       sl_com: new FormControl(0),
  //       in_recargos: new FormControl(0)
  //     }),
  //     datosObservaciones: this.fb.group({
  //       sl_obs1: new FormControl(null),
  //       sl_obs2: new FormControl(null),
  //       sl_obs4: new FormControl(null),
  //     }),
  //     datosUnidades: this.fb.group({ incisos: new FormControl(null) })
  //   });
  // }

  // crearIncisosForm(): FormGroup {
  //   return this.fb.group({
  //     in_id: new FormControl(null),
  //     in_cia: new FormControl(null),
  //     in_pol: new FormControl(null),
  //     in_tipo: new FormControl(null),
  //     in_llave: new FormControl(null),
  //     in_num: new FormControl(null),
  //     in_dato1: new FormControl(null),
  //     in_dato2: new FormControl(null),
  //     in_dato3: new FormControl(null),
  //     in_dato4: new FormControl(null),
  //     in_dato5: new FormControl(null),
  //     in_dato6: new FormControl(null),
  //     in_fecha1: new FormControl(null),
  //     in_fecha2: new FormControl(null),
  //     in_numero1: new FormControl(null),
  //     in_numero2: new FormControl(null),
  //     in_ramo: new FormControl(null),
  //     in_imp1: new FormControl(null),
  //     in_imp2: new FormControl(null),
  //     in_falta: new FormControl(null),
  //     in_cob: new FormControl(null),
  //     in_primaneta: new FormControl(null),
  //     in_descuento: new FormControl(null),
  //     in_recargos: new FormControl(null),
  //     in_gastos: new FormControl(null),
  //     in_iva: new FormControl(null),
  //     in_total: new FormControl(null),
  //     in_prodcob1: new FormControl(null),
  //     in_prodcob2: new FormControl(null),
  //     in_prodcob3: new FormControl(null),
  //     in_prodcob4: new FormControl(null),
  //     in_prodcob5: new FormControl(null),
  //     in_prodcob6: new FormControl(null),
  //     in_estado: new FormControl(null),
  //     actualizacion: new FormControl(null)
  //   });
  // }

  obtenerOpcionesRangePicker(): any {
    const anioActual = new Date();
    const anioSiguiente = new Date(anioActual.getFullYear() + 1, anioActual.getMonth() + 1, anioActual.getDate());
    const today = new Date();
    const fromMin = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    const fromMax = new Date(today.getFullYear() + 2, today.getMonth(), today.getDate());
    const toMin = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
    const toMax = new Date(today.getFullYear() + 2, today.getMonth(), today.getDate());
    return {
      placeholder: 'Seleccione las fechas de vigencia',
      startDatePrefix: 'Del:',
      endDatePrefix: 'Al:',
      presets: this.setupPresets(),
      format: 'mediumDate',
      range: { fromDate: anioActual, toDate: anioSiguiente },
      applyLabel: 'Aplicar',
      calendarOverlayConfig: {
        shouldCloseOnBackdropClick: false,
        hasBackdrop: true
      },
      cancelLabel: 'Cancelar',
      excludeWeekends: false,
      fromMinMax: { fromDate: fromMin, toDate: fromMax },
      toMinMax: { fromDate: toMin, toDate: toMax }
    };
  }

  // helper function to create initial presets
  setupPresets(): any {

    const backDate = (numOfDays) => {
      const hoy = new Date();
      return new Date(hoy.setDate(hoy.getDate() - numOfDays));
    };

    const today = new Date();
    const minus30 = backDate(30);
    const currMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const currMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
    const nextYear = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());

    return [
      { presetLabel: 'Ultimos 30 dias', range: { fromDate: minus30, toDate: today } },
      { presetLabel: 'Este Mes', range: { fromDate: currMonthStart, toDate: currMonthEnd } },
      { presetLabel: 'Este Año', range: { fromDate: today, toDate: nextYear } },
      { presetLabel: 'Mes pasado', range: { fromDate: lastMonthStart, toDate: lastMonthEnd } }
    ];
  }

  obtenerPolizas(polizasPorPagina: number, paginaActual: number): any {
    const queryParams = `?limit=${polizasPorPagina}&page=${paginaActual}`;

    return this.http.get(BACKEND_URL + queryParams);
  }

  obtenerObjectoPolizaParaFormulario(poliza: Poliza): any {
    const polizaMapeada: Poliza = poliza;
    let rango: Range = null;
    if (poliza.sl_vig1 && poliza.sl_vig2) {
      rango = { fromDate: poliza.sl_vig1, toDate: poliza.sl_vig2 };
    }

    const datosPoliza = {
      id: polizaMapeada.id,
      sl_cia: polizaMapeada.sl_cia,
      sl_tipo: polizaMapeada.sl_tipo,
      sl_sol: polizaMapeada.sl_sol,
      sl_pol: polizaMapeada.sl_pol,
      sl_edo: polizaMapeada.sl_edo,
      archivos: null,
      sl_mon: polizaMapeada.sl_mon
    };

    const datosContratante = {
      sl_vig1: rango, // SL_VIG1 y SL_VIG2 sl_vig1, sl_vig2
      sl_fpol: polizaMapeada.sl_fpol,
      sl_cap: polizaMapeada.sl_cap,
      sl_num: polizaMapeada.sl_num,
      sl_aseg: polizaMapeada.sl_aseg,
      sl_dom: polizaMapeada.sl_dom,
      sl_falta: polizaMapeada.sl_falta,
      sl_fpa: polizaMapeada.sl_fpa,
      sl_vpag: polizaMapeada.sl_vpag, // SL_VPAG y SL_DESVPAG sl_vpag
      conductoPago: null,
      sl_contrato: polizaMapeada.sl_contrato,
      sl_caratula: polizaMapeada.sl_caratula,
      sl_age: polizaMapeada.sl_age,
      sl_codclt: polizaMapeada.sl_codclt,
      sl_cob: polizaMapeada.sl_cob
    };

    const datosImportes = {
      noCalcularImportes: false,
      sl_pri: polizaMapeada.sl_pri,
      sl_descto: polizaMapeada.sl_descto,
      sl_derp: polizaMapeada.sl_derp,
      sl_iva: polizaMapeada.sl_iva,
      sl_primtot: polizaMapeada.sl_primtot,
      sl_1erp: polizaMapeada.sl_1erp,
      sl_sigp: polizaMapeada.sl_sigp,
      sl_com: polizaMapeada.sl_com,
      sl_pfra: polizaMapeada.sl_pfra
    };

    const datosObservaciones = {
      sl_obs1: polizaMapeada.sl_obs1,
      sl_obs2: polizaMapeada.sl_obs2,
      sl_obs4: polizaMapeada.sl_obs4,
    };

    const datosUnidades = { incisos: polizaMapeada.incisos ? polizaMapeada.incisos : [] };

    const polizaGenerada = {
      datosPoliza: datosPoliza,
      datosContratante: datosContratante,
      datosImportes: datosImportes,
      datosObservaciones: datosObservaciones,
      datosUnidades: datosUnidades
    };

    return polizaGenerada;
  }

  obtenerObjectoPolizaParaFormularioReexpedicion(poliza: Poliza): any {
    const polizaMapeada: Poliza = poliza;

    const datosPoliza = {
      id: polizaMapeada.id,
      sl_cia: polizaMapeada.sl_cia,
      sl_tipo: polizaMapeada.sl_tipo,
      sl_sol: polizaMapeada.sl_sol,
      sl_pol: polizaMapeada.sl_pol,
      sl_edo: polizaMapeada.sl_edo,
      archivos: null,
      sl_mon: polizaMapeada.sl_mon
    };

    const datosContratante = {
      sl_vig1: polizaMapeada.sl_vig1, // SL_VIG1 y SL_VIG2 sl_vig1, sl_vig2
      sl_fpol: polizaMapeada.sl_fpol,
      sl_cap: polizaMapeada.sl_cap,
      sl_num: polizaMapeada.sl_num,
      sl_aseg: polizaMapeada.sl_aseg,
      sl_dom: polizaMapeada.sl_dom,
      sl_falta: polizaMapeada.sl_falta,
      sl_fpa: polizaMapeada.sl_fpa,
      sl_vpag: polizaMapeada.sl_vpag, // SL_VPAG y SL_DESVPAG sl_vpag
      conductoPago: null,
      sl_contrato: polizaMapeada.sl_contrato,
      sl_caratula: polizaMapeada.sl_caratula,
      sl_age: polizaMapeada.sl_age,
      sl_codclt: polizaMapeada.sl_codclt,
      sl_cob: polizaMapeada.sl_cob
    };

    const datosImportes = {
      noCalcularImportes: false,
      sl_pri: polizaMapeada.sl_pri,
      sl_descto: polizaMapeada.sl_descto,
      sl_derp: polizaMapeada.sl_derp,
      sl_iva: polizaMapeada.sl_iva,
      sl_pfra: polizaMapeada.sl_pfra,
      sl_primtot: polizaMapeada.sl_primtot,
      sl_1erp: polizaMapeada.sl_1erp,
      sl_sigp: polizaMapeada.sl_sigp,
      sl_com: polizaMapeada.sl_com
    };

    const datosObservaciones = {
      sl_obs1: polizaMapeada.sl_obs1,
      sl_obs2: polizaMapeada.sl_obs2,
      sl_obs4: polizaMapeada.sl_obs4,
    };


    const datosUnidades = { incisos: polizaMapeada.incisos ? polizaMapeada.incisos : [] };

    const polizaGenerada = {
      datosPoliza: datosPoliza,
      datosContratante: datosContratante,
      datosImportes: datosImportes,
      datosObservaciones: datosObservaciones,
      datosUnidades: datosUnidades
    };

    return polizaGenerada;
  }

  obtenerObjectoPolizaParaFormularioRenovacion(poliza: Poliza): any {
    const polizaMapeada: Poliza = poliza;

    const datosPoliza = {
      id: polizaMapeada.id,
      sl_cia: polizaMapeada.sl_cia,
      sl_tipo: polizaMapeada.sl_tipo,
      sl_sol: polizaMapeada.sl_sol,
      sl_pol: polizaMapeada.sl_pol,
      sl_edo: polizaMapeada.sl_edo,
      archivos: null,
      sl_mon: polizaMapeada.sl_mon
    };

    const datosContratante = {
      sl_vig1: polizaMapeada.sl_vig1, // SL_VIG1 y SL_VIG2 sl_vig1, sl_vig2
      sl_fpol: polizaMapeada.sl_fpol,
      sl_cap: polizaMapeada.sl_cap,
      sl_num: polizaMapeada.sl_num,
      sl_aseg: polizaMapeada.sl_aseg,
      sl_dom: polizaMapeada.sl_dom,
      sl_falta: polizaMapeada.sl_falta,
      sl_fpa: polizaMapeada.sl_fpa + '',
      sl_vpag: polizaMapeada.sl_vpag, // SL_VPAG y SL_DESVPAG sl_vpag
      conductoPago: null,
      sl_contrato: polizaMapeada.sl_contrato,
      sl_caratula: polizaMapeada.sl_caratula,
      sl_age: polizaMapeada.sl_age,
      sl_codclt: polizaMapeada.sl_codclt,
      sl_cob: polizaMapeada.sl_cob
    };

    const datosImportes = {
      noCalcularImportes: false,
      sl_pri: 0,
      sl_descto: 0,
      sl_derp: 0,
      sl_iva: 0,
      sl_primtot: 0,
      sl_1erp: 0,
      sl_sigp: 0,
      sl_com: 0,
      sl_pfra: 0
    };

    const datosObservaciones = {
      sl_obs1: polizaMapeada.sl_obs1,
      sl_obs2: polizaMapeada.sl_obs2,
      sl_obs4: polizaMapeada.sl_obs4,
    };

    const datosUnidades = { incisos: polizaMapeada.incisos ? polizaMapeada.incisos : [] };

    const polizaGenerada = {
      datosPoliza: datosPoliza,
      datosContratante: datosContratante,
      datosImportes: datosImportes,
      datosObservaciones: datosObservaciones,
      datosUnidades: datosUnidades
    };


    return polizaGenerada;
  }

  obtenerPolizasConFiltro(tipoPolizas: string, fecha: string, polizasPorPagina: number, paginaActual: number): Observable<any> {

    const queryParams = `${tipoPolizas}?limit=${polizasPorPagina}&page=${paginaActual}&fecha=${new Date(fecha).toISOString()}`;

    return this.http.get(BACKEND_URL + queryParams);
  }

  eliminarPoliza(poliza: string, compania: string, ramo: string): Observable<any> {
    const httpQueryParams: HttpParams = new HttpParams().append('cia', compania)
      .append('tipo', ramo)
      .append('pol', poliza);
    return this.http.delete(BACKEND_URL, { params: httpQueryParams });
  }


  consultarSolicit(sl_fol: string): Observable<any> {
    const queryParams = `${sl_fol}`;
    return this.http.get(BACKEND_URL_SOLICIT + queryParams);
  }


  existePoliza(poliza: any, compania: any, ramo: any): Observable<any> {
    const httpQueryParams: HttpParams = new HttpParams().append('cia', compania)
      .append('tipo', ramo)
      .append('pol', poliza);
    return this.http.get(BACKEND_URL + 'existepoliza', { params: httpQueryParams });
  }


  obtenerFormasPago(): Observable<any> {
    return this.http.get(BACKEND_URL_FORMAS_PAGO);
  }

  obtenerControl(): Observable<any> {
    return this.http.get(BACKEND_URL_CONTROL);
  }

  guardarPoliza(poliza: any, incisos: Incisos[], ramos: Ramo[]): Observable<any> {

    const postPoliza = this.obtenerObjetoPolizaParaGuardar(poliza, incisos, ramos);
    return this.http.post(BACKEND_URL + 'guardar-manual', postPoliza);
  }

  obtenerObjetoPolizaParaGuardar(poliza: any, incisos: Incisos[], ramos: Ramo[]): any {
    let poCve = ramos.find(ramo => ramo.po_cve === poliza.datosPoliza.sl_tipo);

    if (!poCve) {
      poCve = ramos.find(ramo => ramo.id === poliza.datosPoliza.sl_tipo);
    }

    const polizaDto: Poliza = {
      id: poliza.datosPoliza.id ? poliza.datosPoliza.id : null,
      su_id: null,
      sl_pol: poliza.datosPoliza.sl_pol,
      sl_num: poliza.datosContratante.sl_num,
      tiporeg: null,
      sl_aseg: poliza.datosContratante.sl_aseg,
      sl_frec: null,
      sl_edo: poliza.datosPoliza.sl_edo, // Max length 1
      sl_tipo: poCve.po_cve, // Max length 5
      sl_vig1: poliza.datosContratante.sl_vig1.fromDate,
      sl_vig2: poliza.datosContratante.sl_vig1.toDate,
      // sl_fpa: poliza.datosContratante.sl_fpa,
      sl_cia: poliza.datosPoliza.sl_cia, /// max lenght 3
      sl_age: poliza.datosContratante.sl_age.ag_cve ? poliza.datosContratante.sl_age.ag_cve : poliza.datosContratante.sl_age, /// max lenght 10
      sl_obs1: poliza.datosObservaciones.sl_obs1, /// max lenght 1000
      sl_obs2: poliza.datosObservaciones.sl_obs2, /// max lenght 1000
      sl_obs3: null, /// max lenght 1000
      sl_obs4: poliza.datosObservaciones.sl_obs4, /// max lenght 2000
      sl_nren: null, /// max lenght 50
      sl_sol: poliza.datosPoliza.sl_sol, /// max lenght 25
      sl_pri: poliza.datosImportes.sl_pri,
      sl_descto: poliza.datosImportes.sl_descto,
      sl_pfra: 0,
      sl_derp: poliza.datosImportes.sl_derp,
      sl_iva: poliza.datosImportes.sl_iva,
      sl_com: poliza.datosImportes.sl_com,
      sl_primtot: poliza.datosImportes.sl_primtot,
      sl_saldo: 0,
      sl_1erp: poliza.datosImportes.sl_1erp,
      sl_sigp: poliza.datosImportes.sl_sigp,
      sl_fpol: poliza.datosContratante.sl_fpol,
      sl_fpa: poliza.datosContratante.sl_fpa.numpagos ? poliza.datosContratante.sl_fpa.numpagos : poliza.datosContratante.sl_fpa,
      sl_fren: null,
      sl_pola: null, /// max lenght 25
      sl_renov: null, /// max lenght 25
      sl_gpo: null, /// max lenght 3
      sl_tel: null, /// max lenght 13
      sl_cat: null, /// max lenght 1
      sl_cap: poliza.datosContratante.sl_cap, /// max lenght 50
      sl_cob: poliza.datosContratante.sl_cob.clave ? poliza.datosContratante.sl_cob.clave : poliza.datosContratante.sl_cob, /// max lenght 5
      cobertura: null, /// max lenght 40
      sl_inc: null, /// max lenght 40
      sl_upfec: null,
      sl_upnum: null, /// max lenght 6
      sl_upfol: null, /// max lenght 10
      sl_upliq: null, /// max lenght 10
      sl_codclt: poliza.datosContratante.sl_codclt, /// max lenght 20
      sl_vpag: poliza.datosContratante.sl_vpag, /// max lenght 2
      sl_desvp: poliza.datosContratante.sl_vpag, /// max lenght 15
      sl_plazo: null, /// max lenght 11
      sl_mon: poliza.datosPoliza.sl_mon, /// max lenght 1
      sl_falta: poliza.datosContratante.sl_falta,
      sl_subag: null, /// max lenght 5,
      sl_contrato: poliza.datosContratante.sl_contrato, /// max lenght 25
      sl_expe: null, /// max lenght 1000
      sl_caratula: poliza.datosContratante.sl_caratula, /// max lenght 20
      sl_dom: poliza.datosContratante.sl_dom, /// max lenght 50
      sl_avisoren: null, /// max lenght 1
      ent_sino: null, /// max lenght 1
      ent_aquien: null, /// max lenght 10
      ent_fecha: null,
      ent_nota: null, /// max lenght 250
      orig_comp: null,
      garantiapag: null, /// max lenght 30
      garanemision: null,
      garanaplicacion: null,
      actualizacion: null,
      incisos: incisos
    };

    return polizaDto;
  }


  editarPoliza(poliza: any, incisos: any[], ramos: any[]): any {
    const postPoliza = this.obtenerObjetoPolizaParaGuardar(poliza, incisos, ramos);
    return this.http.post(BACKEND_URL + 'editar-manual', postPoliza);
  }


  consultarUsuarioMms(usuario: string): any {
    return this.authService.validaUsuario(usuario);
  }

  llenarComboCategTareas(): any {
    return this.http.get(BACKEND_URL_CATEG + 'combo-polizas');
  }

  actualizarPolizaAutorizacion(poliza: any, filtro: any, fecha: any, elementosPorPag, pagActual): any {
    const params = {
      poliza: poliza,
      filtro: filtro,
      fecha: fecha,
      elementosPorPag: elementosPorPag,
      pagActual: pagActual
    };

    return this.http.post(BACKEND_URL + 'actualizar-autorizacion', params);
  }

  renovarPoliza(poliza: any, incisos: any[], ramos: any[]): any {
    const postPoliza = this.obtenerObjetoPolizaParaGuardar(poliza, incisos, ramos);
    return this.http.post(BACKEND_URL + 'renovar-manual', postPoliza);
  }

  recibosSinPagar(numPoliza): Observable<any> {
    return this.http.get(BACKEND_URL_RECIBOS + 'recibos-sin-pagar/' + numPoliza);
  }

  obtenerPolizasBusqueda(): any {
    return this.http.get(BACKEND_URL + 'busqueda').pipe(map((data: any) => {
      return data.map(elemento => {
        return {
          ...elemento,
          totpol: ((elemento.sl_pri - elemento.sl_descto) + elemento.sl_derp + elemento.sl_pfra + elemento.sl_iva)
        };
      });

    }));
  }


  obtenerPolizasBusquedaNoCanceladas() {
    return this.http.get(BACKEND_URL + 'busqueda-no-canceladas').pipe(map((data: any) => {
      return data.map(elemento => {
        return {
          ...elemento,
          totpol: ((elemento.sl_pri - elemento.sl_descto) + elemento.sl_derp + elemento.sl_pfra + elemento.sl_iva)
        };
      });

    }));
  }


  obtenerPolizasPorCompaniaPoliza(compania: string, poliza: string): Observable<any> {
    return this.http.get(BACKEND_URL + 'por-compania-poliza', { params: new HttpParams().append('compania', compania).append('poliza', poliza) });
  }

  obtenerPolizasPorNumero(poliza: string): Observable<any> {
    return this.http.get(BACKEND_URL + 'por-poliza', { params: new HttpParams().append('poliza', poliza) });
  }
  cancelarPolizasSeleccionadas(polizas): Observable<any> {
    return this.http.post(BACKEND_URL + 'cancelar-polizas', polizas);
  }

  obtenerContratos(): Observable<any> {
    return this.http.get(BACKEND_URL + 'busqueda/contratos');
  }
}
